// The api uses "null", but "neutral" is more descriptive and less confusing for the code.
export type MessageStatus = boolean | null;

export type ActionStates = {
  liked: MessageStatus;
};

export const getDefaultActionStates: () => ActionStates = () => {
  return {
    liked: null,
  };
};

export type MessageReference = {
  title: string;
  href: string;
  url: string;
  itemType: string;
};

export enum MESSAGE_ROLE {
  SYSTEM = 'system',
  ASSISTANT = 'assistant',
  USER = 'user',
}

export type MessageType = {
  role: MESSAGE_ROLE;
  message: string;
  messageId: string;
  messageReferences?: MessageReference[];
  // This is the last known states from the server.
  // It is used to revert the localActionStates if a server request fails.
  actionStates: ActionStates;
  // localActionStates is the states of the message on the client side.
  // It is used to update the UI immediately.
  localActionStates?: ActionStates;
  failed?: boolean;
  hideReactions?: boolean;
};

export type Messages = {
  sessionId: string;
  messages: MessageType[];
};
